import { render, staticRenderFns } from "./spInformation.vue?vue&type=template&id=b210938c&scoped=true&"
import script from "./spInformation.vue?vue&type=script&lang=js&"
export * from "./spInformation.vue?vue&type=script&lang=js&"
import style0 from "./spInformation.vue?vue&type=style&index=0&id=b210938c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210938c",
  null
  
)

export default component.exports